import { useStagingMode } from "@/hooks/useStagingMode";
import { AlertTriangle } from "lucide-react";

/**
 * Global staging indicator. Rendered once in the app shell so it appears on
 * every route. Non-interactive and out of the way of primary controls.
 */
export function StagingModeBanner() {
  const { isStaging } = useStagingMode();
  if (!isStaging) return null;

  return (
    <div
      role="status"
      aria-label="Staging environment"
      className="pointer-events-none fixed bottom-3 left-3 z-[60] flex items-center gap-1.5 rounded-full border border-accent/40 bg-accent px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-accent-foreground shadow-lg"
    >
      <AlertTriangle className="h-3.5 w-3.5" aria-hidden="true" />
      Staging Mode
    </div>
  );
}
